import { contentStateToString } from "@utils/richText/converters";
import { MediaDto, mediaFromDto, mediaToDto } from "@domain/media/dtos";
import { AboutShareroomDraft, Period, ShareroomPresentation } from "./shareroom";

export interface ShareroomPresentationDto extends Omit<ShareroomPresentation, "video"> {
	video?: MediaDto;
}
interface ShareroomPresentationDraftDto extends Omit<ShareroomPresentation, "video"> {
	assetId?: string;
}
export interface AboutShareroomDraftDto extends Omit<
	AboutShareroomDraft,
	"presentationAsset" | "presentation" | "targetAudience" | "objective" | "schedule" | "formatCourse"
> {
	presentationAsset?: ShareroomPresentationDraftDto;
	presentation?: string;
	targetAudience?: string;
	objective?: string;
	schedule?: string;
	formatCourse?: string;
}

export function aboutShareroomDraftToDto(draft: AboutShareroomDraft): AboutShareroomDraftDto {
	const { presentation, targetAudience, objective, schedule, formatCourse, presentationAsset } = draft;
	return {
		...draft,
		presentationAsset: presentationAsset ? shareroomPresentationDraftToDto(presentationAsset) : undefined,
		presentation: presentation && presentation.getPlainText().trim() ? contentStateToString(presentation) : undefined,
		targetAudience:
			targetAudience && targetAudience.getPlainText().trim() ? contentStateToString(targetAudience) : undefined,
		objective: objective && objective.getPlainText().trim() ? contentStateToString(objective) : undefined,
		schedule: schedule && schedule.getPlainText().trim() ? contentStateToString(schedule) : undefined,
		formatCourse: formatCourse && formatCourse.getPlainText().trim() ? contentStateToString(formatCourse) : undefined,
	};
}

export function shareroomPresentationDraftToDto(draft: ShareroomPresentation): ShareroomPresentationDraftDto {
	const { video } = draft;
	return {
		...draft,
		assetId: video?.id,
	};
}

export function shareroomPresentationToDto(draft: ShareroomPresentation): ShareroomPresentationDto {
	const { video } = draft;
	return {
		...draft,
		video: video ? mediaToDto(video) : undefined,
	};
}

export function shareroomPresentationFromDto(draft: ShareroomPresentationDto): ShareroomPresentation {
	const { video } = draft;
	return {
		...draft,
		video: video ? mediaFromDto(video) : undefined,
	};
}

export interface DataChartFromDto {
	x: string;
	y: number;
}

export function dtoToChart(dto: Array<{ date: string; number: number }>, period: Period): Array<DataChartFromDto> {
	return dto.map((item) => ({
		x:
			period === "SEVENDAYS"
				? new Date(item.date).toLocaleDateString("default", { weekday: "short" })
				: new Date(item.date).toLocaleDateString("default", { month: "short", year: "2-digit" }),
		y: item.number,
	}));
}
